


import { IState } from '../../../../core/IState';
import { RequestDetailController } from "../controllers/requestDetailController"; 
import  "../services/requestDetailService"; 
import "../directives/detail/detailDirective"
import "../directives/materials/materialDirective"
//import "../directives/requestLetter/requestLetterDirective"

import { RequestAllDetails } from "../models/requestAllDetails";
import { RequestDetail } from '../models/requestDetail';

import "../requestDetail.scss"

export const requestDetailState: IState = {
    name: 'requests.requestDetail',
    url: '/detail/{trackingId}',
    controller: RequestDetailController,
    controllerAs: 'vm',
    template: require('../templates/requestDetail.html'),
    data: {
        title: 'Requests',
        navParent: 'requests'
    }
};

angular.module('deliveryCreate.app').config(['$stateProvider', ($stateProvider: angular.ui.IStateProvider) => {
    $stateProvider.state(requestDetailState);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/states/requestDetailState.ts
 **/